export const appConstants = {
    title: 'Interview Calendar',
    version: '2023.06.09',
    company: 'Uchi.ru',
    webApiRoot: 'http://localhost:5000',

    appearance: {
        baseGrey: '#f6f6f6',
        baseWhite: '#ffffff',
        baseRed: '#ff3131',
        lightBlue: '#ebecff',
        selectBlue: '#b3b7ff',
        smallIconSize: 18,
        normalIconSize: 20,
        bigIconSize: 28,
      },
}